import axios from "axios";
import {Storage} from "@/services/Storage";
import {responses} from "@/utils/responses";

export default {
    name: 'tables',
    state: {
        allTables: [],
        isTabOpen: false,
    },
    getters: {
        getAllTables: (state) => state.allTables,
        getIsTabOpen: (state) => state.isTabOpen,
        getTableBySaleNum: (state) => (saleNum) => (state.allTables) ? state.allTables.find(s => s.saleNumber === saleNum) : undefined,
    },

    mutations: {
        setAllTables: (state, payload) => {
            if (payload) {
                return Storage.setTables(payload)
                    .then(() => state.allTables = payload)
            } else {
                return Storage.getAllTables().then(res => state.allTables = (res ? res : []))
            }
        },

        setIsTabOpen: (state, data) => state.isTabOpen = data,

        createTable: (state, payload) => {
            return Storage.createTable(payload).then(() => {
                return Storage.getAllTables().then(res => state.allTables = res)
            });
        },

        editTable: (state, payload) => {
            return Storage.editTable(payload).then(() => {
                return Storage.getAllTables().then(res => state.allTables = res)
            })
        },

        deleteTable: (state, sale_number) => {
            return Storage.deleteTable(sale_number).then(() => {
                return Storage.getAllTables().then(res => state.allTables = res)
            });
        },
    },
    actions: {
        getQuotedTotal : async (context) => {
            let store = await Storage.getDefaultStore();
            let obj = context.getters.getGlobalDateRange;
            let user = await Storage.getCurrentUser();
            obj.User = user.Username;
            return axios.get(backOfficeTomcatApi + `debtor/${store.StoreDB}/getQuotedTotal`,{params : obj})
                .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },

        getAllQuotes : async (context , payload) => {
            let store = await Storage.getDefaultStore();
            let user = await Storage.getCurrentUser();
            let obj = {
                ...context.getters.getGlobalDateRange,
                ...payload,
                User : user.Username,
            };
            return axios.post(backOfficeTomcatApi + `debtor/${store.StoreDB}/getAllQuotes`,obj)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        saveNewTable: async (context, payload) => {
            let refund = false;
            let items = context.getters.getSaleLines;
            for (let i = 0; i < items.length; i++) {
                let line = items[i];
                items[i].Line = Number(line.Qty) * Number(line.Unit);
                if (Number(line.Qty) < 0) refund = true;
            }
            let obj = {
                SaleNum: context.getters.getCurrentSale,
                Name: (payload.name && payload.name.length > 0) ? payload.name : "Table " + context.getters.getCurrentSale,
                User: context.getters.getCurrentUser.Username,
                PC: context.getters.getDeviceSettings.PC,
                items: items,
                Customer: payload.Customer,
                discount : parseFloat(context.getters.getSaleDiscount.total),
                refund : refund,
            }
            return context.dispatch('AddOrUpdateTable', obj)
                .then((res) => res)
                .catch(err => {throw new Error(err)});
        },
        AddOrUpdateTable: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            if (payload.items.length === 0){
                return responses.showWarning(`No items detected`);
            }
            return axios.post(serverApi + `tables/${store.StoreDB}`, payload)
                .then(({data}) => {
                    context.commit('clearSale');
                    return data
                }).catch((err) => errorHandler.tomcatError(err))
        },
        updateTable: (context, payload) => {
            let refund = false;
            let saleLines = context.getters.getSaleLines;
            for (let i = 0; i < saleLines.length; i++) {
                let line = saleLines[i];
                saleLines[i].Line = Number(line.Qty) * Number(line.Unit);
                if (Number(line.Qty) < 0) refund = true;
            }
            let data = {
                SaleNum: context.getters.getCurrentSale,
                Name: (payload.name && payload.name.length > 0) ? payload.name : "Table " + context.getters.getCurrentSale,
                User: context.getters.getCurrentUser.Username,
                PC: context.getters.getDeviceSettings.PC,
                items: saleLines,
                Customer: payload.Customer,
                discount : parseFloat(context.getters.getSaleDiscount.total),
                refund : refund,
            };
            return context.dispatch('AddOrUpdateTable', data)
                .then((res) => context.commit('editTable', res))
        },
        removeTable: async (context, sale_number) => {
            let store = await Storage.getDefaultStore();
            return axios.delete(serverApi + `tables/${store.StoreDB}/void/${sale_number}`)
                .then(async () => {
                    await context.dispatch('getAllTables');
                    return true;
                }).catch((err) => errorHandler.tomcatError(err))
        },
        emailQuote : async (context,payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(franchiseTomcatApi+`emailrecord/${store.StoreDB}/emailQuote`,payload)
                .catch((err) => errorHandler.tomcatError(err))
        },

        downloadQuote : async (context,payload) => {
            let store = await Storage.getDefaultStore();
            return window.open(printApi+`Quotes/${store.StoreDB}/${payload}`)
            // return window.open(franchiseApi+`SaveTable/PrintQuote/${payload}/${store.StoreDB}`)
        },

        downloadInvoiceFromSale : async (context,saleNumber) => {
            let store = await Storage.getDefaultStore();
            return window.open(franchiseApi+`PDFReport/getInvoiceFromSaleNumber/${saleNumber}/${store.StoreDB}`)
        },
        getTableData : async (context , saleNumber) => {
            let store = await Storage.getDefaultStore();
            return axios.get(franchiseTomcatApi+`savetable/${store.StoreDB}/${saleNumber}`)
                .then(({data}) => data)
                .catch(err=>errorHandler.tomcatError(err))
        },
        getTableBySaleNumber : async (context , saleNumber) => {
            return context.dispatch(`getTableData`,saleNumber).then(res=> {
                let tabs = []
                tabs.push(res)
                return Promise.all([
                    context.dispatch(`openTable`, res),
                    context.commit('setAllTables', tabs)
                ])
            })
        },
    }
}
